import React from 'react';
import {Link} from "react-router-dom";
import logo from "../assets/ctrl4.png";
import { useNavigate } from "react-router-dom";
import "./Layout.css";


const Layout = ({ children }) => {
  const navigate = useNavigate();

    return (
        <>
            <header className='layout-header'>
                <Link to="/">
                    <img src={logo} alt="ctrl4.gg" className="layout-logo"/>
                </Link>
                <button
                  className="layout-login-btn"
                  onClick={() => navigate("/login")}
                  >
                  로그인
                  </button>
            </header>
            <main className="layout-main">
                {children}
            </main>
            <footer className="layout-footer">
                ⓒ 2025 Ctrl4
            </footer>
        </>
    );
};

export default Layout;